<template>
  <div>
    <WebInput
      v-model="zipCode"
      :class-name="inputClass"
      :tab-index="inputTabIndex"
      :placeholder="translate('generate.placeholder.zipCode', locale)"
      :name="name"
      type="mask"
      :mask="/^[\d-]*$/"
      :label="getInputLabel(translate('generate.label.zipCode', locale), isLabelVisible)"
      :label-style="labelStyle"
      :disabled="isSubmitDisabled || isSubmitLoading || disabled"
      rules="required|zipCode"
      :page-options="pageOptions"
      @error="handleInputError"
    />
  </div>
</template>

<script lang="ts" setup>
import { type PropType, computed, toRefs } from 'vue';
import { useTranslate } from '@shared/composable/useTranslate';
import { useLabelOptions } from '@shared/composable/useLabelOptions';
import WebInput from '@shared/components/input/index.vue';
import type { Element as ElementType, PageOptions } from '@shared/types/model';

const emit = defineEmits(['error']);
const props = defineProps({
  name: { type: String, default: 'ZipCodeInput' },
  locale: { type: String, default: '' },
  isEditorMode: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  element: { type: Object as PropType<ElementType<'payment' | 'payment-with-tabs'>>, default: () => ({}) },
  pageData: { type: Object as PropType<Record<string, any>>, default: () => ({}) },
  pageOptions: { type: Object as PropType<PageOptions>, default: () => ({}) },
});

const { translate } = useTranslate();

const { element, pageOptions } = toRefs(props);
const { labelStyle, isLabelVisible } = useLabelOptions({ element, pageOptions });

const zipCode = defineModel<string | number>('modelValue', { default: '' });

const isSubmitLoading = computed(() => props.pageData?.isSubmitLoading);
const isSubmitDisabled = computed(() => props.pageData?.isSubmitDisabled);
const inputTabIndex = computed(() => (props.isEditorMode ? '-1' : undefined));
const inputClass = computed(() => ({
  'mb-16': true,
  'pointer-events-none': props.isEditorMode
}));

function getInputLabel(label = '', show = true) {
  return show ? label : '';
}

function handleInputError(errMessage: string) {
  emit('error', errMessage);
}
</script>
